import { connect } from 'react-redux';

import { selectLayersTab } from '../actions';
import LayersTabs from '../components/LayersTabs';

const mapStateToProps = ({ mapLayers, sidebar }) => {
  const { dataLayers } = mapLayers;
  const { selectedTab } = sidebar;

  // create an array of strings of unique "themes" for the data layers
  const themes = Object.values(dataLayers).reduce((arr, cur) => {
    const { theme } = cur;
    if (arr.indexOf(theme) === -1) {
      return [...arr, theme];
    }
    return arr;
  }, []);

  return {
    selectedTab,
    themes,
  };
};

export default connect(mapStateToProps, { selectLayersTab })(LayersTabs);



// WEBPACK FOOTER //
// ./src/containers/LayersTabsConnected.jsx